import { call, put, select, takeLatest } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/payments/actions';
import * as types from 'modules/payments/actionTypes';
import { getBaseRequestParams } from 'modules/payments/selectors';
import { createNotification } from 'modules/toast-notifications/actions';

function* fetchPaymentsWorker({ payload: { request }, meta }) {
  try {
    const { data } = yield call(restClient.request, request);
    yield put(actions.fetchPaymentsSuccess(data, meta));
  } catch (error) {
    yield put(actions.fetchPaymentsFailure(error, meta));
  }
}

function* fetchTotalAmountWorker({ payload: { request }, meta }) {
  try {
    const { data } = yield call(restClient.request, request);
    yield put(actions.fetchTotalAmountSuccess(data.content?.[0].amount ?? 0, meta));
  } catch (error) {
    yield put(actions.fetchTotalAmountFailure(error, meta));
  }
}

function* refreshDashboard() {
  const { page: _, ...params } = yield select(getBaseRequestParams);
  yield put(actions.fetchPayments({ ...params, page: 0 }, { source: 'payments-dashboard' }));
  yield put(actions.fetchTotalAmount(params, { source: 'payments-dashboard' }));
}

function* exportPaymentWorker({ payload: { request }, meta }) {
  try {
    yield call(restClient.request, request);
    yield put(actions.exportPaymentSuccess(meta));
    yield put(
      createNotification({
        type: 'success',
        message: {
          id: 'statistics_intervention.export_success',
          defaultMessage: 'Export in progress. Please check your inbox in a few minutes.',
        },
      })
    );
  } catch (error) {
    yield put(actions.exportPaymentFailure(error, meta));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'page.payment.exportError',
          defaultMessage: 'An error occurred during the export of the payments.',
        },
      })
    );
  }
}

const onFilterChange = ({ type }) =>
  [
    SELECT_DEALER,
    types.SET_PAYMENT_DASHBOARD_FILTER,
    types.SET_PAYMENT_DASHBOARD_FILTERS,
    types.CLEAR_PAYMENT_DASHBOARD_FILTER,
    types.REMOVE_PAYMENT_DASHBOARD_FILTER,
  ].includes(type);

function* onPageWorker() {
  yield call(refreshDashboard);
  yield takeLatest(onFilterChange, refreshDashboard);
}

export default function* interventionsMobilitySagas() {
  // Actions
  yield scopeToPage([PATH.PAYMENT], onPageWorker);

  // Request
  yield takeLatest(types.FETCH_PAYMENTS, fetchPaymentsWorker);
  yield takeLatest(types.FETCH_TOTAL_AMOUNT, fetchTotalAmountWorker);
  yield takeLatest(types.EXPORT_PAYMENT_REQUEST, exportPaymentWorker);
}
